import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import {affiliateId, auth , editor , publisher, user} from "../slices/auth-slice"

interface ProtectedRouteProps {
  children: JSX.Element;
  allowedRole: 'publisher' | 'editor' | 'user';
}

export default function ProtectedRoute({ children, allowedRole }: ProtectedRouteProps) {
  const authStatus = useAppSelector(auth);
  const publisherStatus = useAppSelector(publisher);
  const editorStatus = useAppSelector(editor);
  const userStatus = useAppSelector(user);
  const affiliate = useAppSelector(affiliateId);

  if (!authStatus) {
    return <Navigate to="/" />;
  }

  if (allowedRole === 'publisher' && !publisherStatus ) {
    return <Navigate to="/publisher-dashboard" />;
  }

  if (allowedRole === 'editor' && !editorStatus) {
    return <Navigate to="/editor-dashboard" />;
  }

  if (allowedRole === 'user' && !userStatus && affiliate !== null) {
    return <Navigate to="/user-dashboard" />;
  }

  return children;
}
